import { useState, useContext } from 'react'
import { Form, Input, Button, Checkbox, Card, Tabs, message } from "antd";
import { UserOutlined, LockOutlined, HomeOutlined } from "@ant-design/icons";
import Animate from 'rc-animate';
import { useNavigate } from 'react-router-dom';
import { Typography } from "antd";
import axios from 'axios';
import videoBg from '../assets/bg/bg.mp4'
import imageBg from '../assets/bg/bg.png'
import { AuthContext } from '../context/AuthContext'

import '../style/Login.css';
const { Title, Paragraph } = Typography;


const Login = () => {
    const auth = useContext(AuthContext)
    const navigate = useNavigate()
    const [rules, setRules] = useState(true)
    const [formLayout, setFormLayout] = useState('vertical');
    const [loginType, setLoginType] = useState('enter');
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        setLoading(true);
        axios.post('/api/user/login', { email: values.email, password: values.password })
            .then(res => {
                if (res.status === 200) {
                    if (!!res.data.expiry && !!res.data.access_token) {
                        auth.login(res.data.access_token, 1, res.data.expiry, values.email)
                        navigate('/')
                    } else {
                        message.warning('Ошибка. Попробуйте, пожалуйста, еще раз', 2)
                    }
                } else {
                    message.warning('Ошибка. Попробуйте, пожалуйста, еще раз', 2)
                }
            })
            .catch((error) => {
                if (error.response.status === 500) {
                    message.error('Ошибка сервера. Попробуйте, пожалуйста, позже', 2)
                } else if (error.response.status === 401) {
                    message.warning('Пользователь не найден', 2)
                } else if (error.response.status === 403) {
                    message.warning('Аккаунт ожидает подтверждения. При регистрации на Вашу почту было отправлено письмо', 2)
                }
            })
            .finally(() => {
                setLoading(false);
            })

        if (values.remember) {

            // localStorage.setItem("username", values.username);
            // localStorage.setItem("password", values.password);
        }
    };

    const onFinishRegistartion = (values) => {
        if (rules) {
            setLoading(true);
            axios.post('/api/user/registration', { email: values.email, password: values.password, company: values.company })
                .then(res => {
                    if (res.status === 201) {
                        if (res.data.status == 'ok') {
                            setLoginType('enter')
                            message.success('Регистрация прошла успешно.\nВам необходимо подтвердить Вашу почту.\nМы отправили Вам письмо на указанный почтовый адрес', 7)
                            // auth.login(res.data.access_token, 1, res.data.expiry, values.email)
                            // navigate('/')
                        } else {
                            message.warning('Ошибка. Попробуйте, пожалуйста, еще раз', 2)
                        }
                    } else {
                        message.warning('Ошибка. Попробуйте, пожалуйста, еще раз', 2)
                    }
                })
                .catch((error) => {
                    if (error.response.status === 500) {
                        message.error('Ошибка сервера. Попробуйте, пожалуйста, позже', 2)
                    } else if (error.response.status === 401) {
                        message.warning('Пользователь уже существует', 2)
                    }
                })
                .finally(() => {
                    setLoading(false);
                })
        } else {
            message.warning('Необходимо согласиться с правилами', 2)
        }

        if (values.remember) {

            // localStorage.setItem("username", values.username);
            // localStorage.setItem("password", values.password);
        }
       
    };

    const handleForgotPassword = (e) => {
        e.preventDefault();
        console.log("Handle password recovery logic here");
    };

    const handleRegister = (e) => {
        e.preventDefault();
        setLoginType('registration')
    };

    const handleEnter = (e) => {
        e.preventDefault();
        setLoginType('enter')
    }

    return (
        <div
            className="main"
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            {/* <video src={videoBg} autoPlay loop muted>

            </video> */}

            <div className='content'>
                <Animate

                >
                    <Card className='card' style={{
                        width: 370,

                        // boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
                    }}>
                        {/* <img src={imageBg} style={{ width: '100%', position: 'absolute', bottom: '-150px', left: '220px', opacity: '0.7' }}></img> */}
                        <div className='header'>
                            <Title level={2} style={{ 'color': '#383741', 'fontSize': '34px' }}>EGC</Title>
                            <Paragraph type="secondary" style={{ 'color': '#383741', 'fontSize': '22px' }}>Every Guest Counts</Paragraph>
                        </div>
                        <Tabs
                            centered
                            activeKey={loginType}
                            style={{ 'color': '#383741', 'marginBottom': '15px' }}
                            color='#383741'
                            tabBarStyle={{
                                color: '#383741 !important',
                                font: "#383741 !important"
                            }}
                            onChange={(activeKey) => setLoginType(activeKey)}
                        >
                            <Tabs.TabPane class='tabs123' sx={{ color: "#383741", font: "#383741 !important" }} color='#383741' key={'enter'} style={{ 'color': '#383741 !important' }} tab={'Войти'} />
                            <Tabs.TabPane className='tabs' sx={{ color: "#383741", font: "#383741 !important" }} key={'registration'} style={{ 'color': '#383741 !important', font: "#383741 !important" }} tab={'Зарегистрироваться'} />
                        </Tabs>
                        {loginType == 'enter' && <Form
                            name="normal_login"
                            className="login-form"
                            initialValues={{ remember: true }}
                            onFinish={onFinish}
                        >
                            <Form.Item
                                name="email"
                                rules={[{
                                    type: 'email',
                                    message: "Введите корректный Email, пожалуйста",
                                },
                                {
                                    required: true,
                                    message: "Пожалуйста, введите Email"
                                }]}
                            >
                                <Input
                                    prefix={<UserOutlined className="site-form-item-icon" />}
                                    placeholder="Email"
                                />
                            </Form.Item>
                            <Form.Item
                                style={{ 'marginBottom': '35px' }}
                                name="password"
                                rules={[{ required: true, message: "Пожалуйста, введите пароль" }]}
                            >
                                <Input
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    type="password"
                                    placeholder="Пароль"
                                />

                            </Form.Item>
                            <Form.Item>
                                <Button
                                    style={{ marginBottom: '15px', background: '#7433D6', fontSize: '16px', height: '44px' }}
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    className="login-form-button"
                                    block
                                >
                                    Войти
                                </Button>
                                {/* <div style={{ textAlign: 'center' }}>
                                    <a
                                        className="login-form-forgot"
                                        href=""
                                        onClick={handleForgotPassword}
                                    >
                                        Забыли пароль?
                                    </a>
                                </div> */}

                                <Paragraph style={{ 'color': '#383741', fontSize: '16px' }}>У Вас нет аккаунта?{" "}
                                    <a href="" onClick={handleRegister}>
                                        Зарегистрироваться
                                    </a>
                                </Paragraph>
                            </Form.Item>
                        </Form>}
                        {loginType == 'registration' && <Form
                            layout={formLayout}
                            name="normal_login"
                            className="login-form"
                            autocomplete="off"
                            // initialValues={{ remember: true }}
                            onFinish={onFinishRegistartion}
                        >
                            <Form.Item
                                label="Почта"
                                autoComplete="new-state"
                                name="email"
                                rules={[{
                                    type: 'email',
                                    message: "Введите корректный Email, пожалуйста",
                                },
                                {
                                    required: true,
                                    message: "Пожалуйста, введите Email"
                                }]}
                            >
                                <Input
                                    name="email"
                                    autoComplete="new-state"
                                    prefix={<UserOutlined className="site-form-item-icon" />}
                                    placeholder="Email"
                                />
                            </Form.Item>
                            <Form.Item
                                autoComplete="new-state"
                                label="Наименование компании"
                                name="company"
                                rules={[
                                    {
                                        required: true,
                                        message: "Пожалуйста, введите наименование компании"
                                    }]}
                            >
                                <Input
                                    name="company"
                                    autoComplete="new-state"
                                    prefix={<HomeOutlined className="site-form-item-icon" />}
                                    placeholder="Наименование компании"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Пароль"
                                style={{ 'marginBottom': '35px' }}
                                name="password"
                                rules={[{ required: true, message: "Пожалуйста, введите пароль" }]}
                            >
                                <Input
                                    autoComplete="nope"
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    type="password"
                                    placeholder="Пароль"
                                />

                            </Form.Item>
                            <Form.Item>
                                <Form.Item name="rules" valuePropName="checked" noStyle
                                    rules={[{ required: true, message: "Пожалуйста, ознакомьтесь с правилами" }]}>
                                    <Checkbox checked={rules} onChange={(e) => {
                                        setRules(e.target.checked)
                                    }}>Нажимая "Зарегистрироваться" Вы соглашаетесь с <a href="https://egcounts.space/assets/pdf/term_EGC.pdf">правилами</a></Checkbox>
                                </Form.Item>
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    style={{ marginBottom: '15px', background: '#7433D6', fontSize: '16px', height: '44px' }}
                                    type="primary"
                                    loading={loading}
                                    htmlType="submit"
                                    className="login-form-button"
                                    block
                                >
                                    Зарегистрироваться
                                </Button>

                                <Paragraph style={{ 'color': '#383741', fontSize: '16px' }}>У Вас есть аккаунт?{" "}
                                    <a href="" onClick={handleEnter}>
                                        Войти
                                    </a>
                                </Paragraph>
                            </Form.Item>
                        </Form>}

                    </Card>
                </Animate>
            </div>
        </div>
    );
}
export default Login;